import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { ApiService } from "../Components/Service/apiservices";

function SocialLinks() {
    const [themeAdmin, setThemeAdmin] = useState([]);
    const didMountRef = useRef(true);
    const [isLoading, setisLoading] = useState(true)
    useEffect(() => {
        if (didMountRef.current) {
            getCommonData()

        }
        didMountRef.current = false
    })
    const getCommonData = () => {
        ApiService.fetchData("common").then((res) => {
            if (res.status == "success") {
                setThemeAdmin(res.themesAdmin);
                setTimeout(() => {
                    setisLoading(false)
                }, 500)
            }
        }).catch(() => {
        });
    };
   return (
        <div className="footer_social d-flex align-items-center justify-content-center mb-4">
            {themeAdmin.instagram_url && (
                <Link to={themeAdmin.instagram_url} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-instagram"></i>
                </Link>
            )}
            {themeAdmin.facebook_url && (
                <Link to={themeAdmin.facebook_url} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-facebook"></i>
                </Link>
            )}
            {themeAdmin.pintrest_url && (
                <Link to={themeAdmin.pintrest_url} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-pinterest"></i>
                </Link>
            )}
            {themeAdmin.youtube_url && (
                <Link to={themeAdmin.youtube_url} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-youtube"></i>
                </Link>
            )}
            {themeAdmin.linkedin_url && (
                <Link to={themeAdmin.linkedin_url} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-linkedin"></i>
                </Link>
            )}
        </div>
    );

}
export default SocialLinks;